/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *---------------------------------------------------
 */
//Standard libraries
import { useTranslation } from "react-i18next";
//UI
import { StyledGrid } from "@hcl-commerce-store-sdk/react-component";
//Custom libraries
import { ProductCardLayout } from "../../../components/widgets/product-card";
import { useCallback, useEffect } from "react";
import * as wishListActions from "../../../redux/actions/wish-list";
import { useDispatch, useSelector } from "react-redux";
import Axios, { Canceler } from "axios";
import { loginStatusSelector } from "../../../redux/selectors/user";
import HTMLReactParser from "html-react-parser";
/**
 * Product Card component
 * displays catentry image, name, price, etc
 * @param props
 */
export default function useProductCardWidget(props: any) {
  const { productListTotal, productList, categoryId, selectedFacets, priceSelected, ...rest } = props;
  const page = props.page;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const CancelToken = Axios.CancelToken;
  const cancels: Canceler[] = [];
  const loginStatus = useSelector(loginStatusSelector);
  const banner = props.bannerContent;

  let facetColor = "";
  Object.entries(selectedFacets).map(([key, value]) => {
    if (value === "Color") {
      facetColor = key;
    }
  });

  const getList = useCallback(async () => {
    dispatch(
      wishListActions.GET_USER_WISHLIST_ACTION({
        widget: "AddToWishListButton",
        cancelToken: new CancelToken((c) => cancels.push(c)),
      })
    );
  }, [dispatch, CancelToken]);

  useEffect(() => {
    if (loginStatus) {
      getList();
    }
  }, [loginStatus]);

  return (
    <StyledGrid container spacing={1} alignItems="stretch" direction="row" className="plp-products-grid">
      {banner && banner.left ? (
        <StyledGrid item xs={6} sm={4} lg={3} className="plp-leftbanner full-grid-view">
          <div id="leftBanner">{Object.entries(banner.left).map(([key, value]: any) => HTMLReactParser(value))}</div>
        </StyledGrid>
      ) : null}
      {productListTotal > 0 ? (
        productList?.map((product) => (
          <StyledGrid className="full-grid-view" item xs={6} sm={4} lg={3} key={product.id}>
            <ProductCardLayout
              product={product}
              categoryId={categoryId}
              selectedFacets={selectedFacets}
              facetColor={facetColor}
              page={page}
              {...rest}
            />
          </StyledGrid>
        ))
      ) : (
        <>
          {productListTotal === 0 && (Object.keys(selectedFacets)?.length > 0 || priceSelected) ? (
            <StyledGrid item xs={12}>
              {t("ProductGrid.Labels.noProductsFoundForFilter")}
            </StyledGrid>
          ) : null}
        </>
      )}
    </StyledGrid>
  );
}
